"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StoreImportCampaignsInnerToJSON = exports.StoreImportCampaignsInnerFromJSONTyped = exports.StoreImportCampaignsInnerFromJSON = exports.instanceOfStoreImportCampaignsInner = void 0;
var runtime_1 = require("../runtime");
/**
 * Check if a given object implements the StoreImportCampaignsInner interface.
 */
function instanceOfStoreImportCampaignsInner(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfStoreImportCampaignsInner = instanceOfStoreImportCampaignsInner;
function StoreImportCampaignsInnerFromJSON(json) {
    return StoreImportCampaignsInnerFromJSONTyped(json, false);
}
exports.StoreImportCampaignsInnerFromJSON = StoreImportCampaignsInnerFromJSON;
function StoreImportCampaignsInnerFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'referenceId': !(0, runtime_1.exists)(json, 'reference_id') ? undefined : json['reference_id'],
        'closesAt': !(0, runtime_1.exists)(json, 'closes_at') ? undefined : json['closes_at'],
        'expectedQuantity': !(0, runtime_1.exists)(json, 'expected_quantity') ? undefined : json['expected_quantity'],
    };
}
exports.StoreImportCampaignsInnerFromJSONTyped = StoreImportCampaignsInnerFromJSONTyped;
function StoreImportCampaignsInnerToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'reference_id': value.referenceId,
        'closes_at': value.closesAt,
        'expected_quantity': value.expectedQuantity,
    };
}
exports.StoreImportCampaignsInnerToJSON = StoreImportCampaignsInnerToJSON;
